module.exports = __webpack_public_path__ + "static/img/logo2.7ba65d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/logo2.png
// module id = Q3sQ
// module chunks = 1